// @ts-nocheck
/**
 * Product List Tabs
 * Handles tab switching for the product-list-tabs section.
 * Each tab shows a different collection's products.
 */

class ProductListTabs {
  constructor(section) {
    this.section = section;
    this.buttons = section.querySelectorAll('.product-list-tabs__btn');
    this.panels = section.querySelectorAll('.product-list-tabs__panel');
    this.viewAllLink = section.querySelector('[data-tabs-view-all]');

    if (!this.buttons.length) return;

    this.buttons.forEach((btn) => {
      btn.addEventListener('click', () => this.activateTab(btn));
    });
  }

  activateTab(activeBtn) {
    const targetId = activeBtn.dataset.tabId;

    this.buttons.forEach((btn) => {
      const isActive = btn.dataset.tabId === targetId;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      const isActive = panel.dataset.tabPanel === targetId;
      panel.classList.toggle('hidden', !isActive);
    });

    if (this.viewAllLink) {
      const collectionUrl = activeBtn.dataset.collectionUrl;
      if (collectionUrl) {
        this.viewAllLink.setAttribute('href', collectionUrl);
      }
    }
  }
}

function initProductListTabs() {
  document.querySelectorAll('.section-product-list-tabs').forEach((section) => {
    new ProductListTabs(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductListTabs);
} else {
  initProductListTabs();
}

// Re-initialize when Shopify theme editor reloads sections
document.addEventListener('shopify:section:load', (event) => {
  const section = /** @type {HTMLElement} */ (event.target)?.querySelector('.section-product-list-tabs');
  if (section) new ProductListTabs(section);
});
